// removed by extract-text-webpack-plugin
module.exports = {"list":"_1rg0_vwQkx4L3W8m876Dpv","listItemIcon":"_1LtIlrkudsyuH7bVfNO_s4"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/navigation/sidebar-navigation.scss
// module id = 108
// module chunks = 0